"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useContext, type ComponentProps } from "react";
import { LandvestHandoffContext } from "@/components/providers/LandvestHandoffContext";
import { routes } from "@/lib/routes";
type LandvestHandoffLinkProps = Omit<ComponentProps<typeof Link>, "href"> & {
  href: string;
};

/**
 * `next/link` for config-driven site chrome (footer, nav, hero cards) whose
 * href may be the retired `/flaechen-pruefen` route. That route only 308s to
 * LandVest, so linking it from the footer made every page link to a redirect
 * (Ahrefs site audit, 2026-10-15). This links the hand-off URL directly; every
 * other href passes through. Without a provider (component library, isolated
 * tests) the route itself is kept — it still redirects, so nothing breaks.
 */
export function LandvestHandoffLink(t0) {
  const $ = _c(6);
  let href;
  let props;
  if ($[0] !== t0) {
    ({
      href,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = href;
    $[2] = props;
  } else {
    href = $[1];
    props = $[2];
  }
  const handoffUrl = useContext(LandvestHandoffContext);
  const resolvedHref = href === routes.flaechenPruefen && handoffUrl ? handoffUrl : href;
  let t1;
  if ($[3] !== props || $[4] !== resolvedHref) {
    t1 = <Link href={resolvedHref} {...props} />;
    $[3] = props;
    $[4] = resolvedHref;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}